import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const BASE_URL = `${apiUrl}authentication`;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchConversations = async (senderId) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const response = await fetch(
        `${apiUrl}messaging/api/conversations/${senderId}/`
    );

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
   console.log('data in fetchConversations :',data)
    if (data.status === "success") {
        return data.conversations;
    } else {
        throw new Error("Failed to fetch conversations");
    }
};

export const getDiscussionUsers = async (userId) => {
    try {
      const response = await apiClient.get('/get-discussion-users/', {
        params: { user_id: userId }, // Pass user_id as a query parameter
      });
      return response.data; // Response includes the list of discussion users
    } catch (error) {
      throw error.response?.data || 'Error fetching discussion users';
    }
  };